module.exports = __webpack_public_path__ + "static/media/calender.51d4ed92.svg";